import React from 'react';
import { MainSearchView } from '../../search/main-search';
import { MainSearchProps } from '../../search/main-search/main-search';

export const RocheSearch = (props: MainSearchProps): JSX.Element => {
  return <MainSearchView {...props} />;
};
